import { render, staticRenderFns } from "./Debitsales.vue?vue&type=template&id=52f44c5d"
import script from "./Debitsales.vue?vue&type=script&lang=js"
export * from "./Debitsales.vue?vue&type=script&lang=js"
import style0 from "./Debitsales.vue?vue&type=style&index=0&id=52f44c5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports